import clsx from 'clsx';
import React from 'react';
import FEMobileBarProps from './props';
import style from './style.module.css';

const FEMobileBar = ({
  label,
  value,
  onClick,
  placeholder,
  valueIcon,
  theme = 'primary',
  color = 'black',
  isOpenStartAppConfirmation
}: FEMobileBarProps) => {

  return (
    <div className={theme === "primary" ? style.root : style.rootOutline} onClick={onClick}>
      <div className={style.container}>
        {!isOpenStartAppConfirmation ? <div className={style.data}>
          <p className={clsx('caption-1', color === 'black' ? style.label : style.labelWhite)}>{label}</p>
          <div className={style.valueContainer}>
            <p className={clsx('headline', color === 'black' ? style.value : style.valueWhite)}>
              {value ?? placeholder}
            </p>
            {value !== null && valueIcon !== undefined && (
              <img src={valueIcon} alt='' />
            )}
          </div>
        </div>
          : <div className={style.startAppLabelContainer}>
            <p className={clsx(color === 'black' ? style.startAppLabel : style.startAppWhiteLabel)}>
              Товары и цены зависят от адреса
            </p>
            <p className={clsx(color === 'black' ? style.startAppLabelValue : style.startAppWhiteLabelValue)}>
              Уточните адрес
            </p>
          </div>

        }
      </div>
    </div>
  );
};

export default FEMobileBar;
export type { FEMobileBarProps };
